export default "__VITE_ASSET__DtQbB97I__"